import { PageName } from '@@/page_pb'

export enum KP_VAR {
  KP_ADVERTISINGID = '_kp_webAdvertisingId',
  KP_DEVICEID = '_kp_webDeviceId',
}

export enum PageNameEnum {
  '/' = PageName.HOMEPAGE,
  '/pintar-score' = PageName.PINTARSCOREPAGE,
  '/pintar-shop' = PageName.PINTARSHOPPAGE,
  '/product' = PageName.PRODUCTPAGE,
  '/faq' = PageName.FAQPAGE,
  '/about-us' = PageName.ABOUTUSPAGE,
  '/career' = PageName.CAREERPAGE,
  '/education' = PageName.EDUCATIONPAGE,
  '/competition' = PageName.KPWEBSITECOMPETITION,
  '/privacy-policy' = PageName.KPPRIVACYPOLICY,
  '/terms-of-service' = PageName.KPTERMSOFSERVICE,
  '/search' = PageName.KPWEBSITESEARCH,
  '/sitemap' = PageName.KPSITEMAP,
  '/education-category/[slug]' = PageName.EDUCATIONPAGE,
  '/education-tag/[slug]' = PageName.EDUCATIONPAGE,
  '/education/[slug]' = PageName.EDUCATIONPAGE,
  '/external-privacy-policy' = PageName.KPPRIVACYPOLICY,
  '/external-terms-of-service' = PageName.KPTERMSOFSERVICE,
  '/activity/pintar-discover' = PageName.POSTLIST,
  '/activity/pintar-discover/page/[page]' = PageName.POSTLIST,
  '/activity/pintar-discover/[id]' = PageName.POSTDETAIL,
}

export enum OtherUrl {
  PINTARSCORE = '/activity/credit-score',
  PINTARSHOP = '/activity/pintar-shop',
}
